import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "margin-top-min" }
const _hoisted_2 = {
  key: 1,
  class: "m-pageCW-list margin-bottom-min"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorkListSkeleton = _resolveComponent("WorkListSkeleton")!
  const _component_WorkItem = _resolveComponent("WorkItem")!
  const _component_alert_search = _resolveComponent("alert-search")!
  const _component_paginate = _resolveComponent("paginate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_WorkListSkeleton, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.works.length > 0)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.works, (work) => {
                  return (_openBlock(), _createBlock(_component_WorkItem, {
                    key: work.id,
                    work: work,
                    statuses: _ctx.statuses,
                    executors: _ctx.executors,
                    categories: _ctx.categories
                  }, null, 8 /* PROPS */, ["work", "statuses", "executors", "categories"]))
                }), 128 /* KEYED_FRAGMENT */))
              : (_ctx.shouldShowAlert)
                ? (_openBlock(), _createBlock(_component_alert_search, {
                    key: 1,
                    title: 'Строительные работы не найдены'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" В данный момент работы не проводятся или по вашему запросу нет результатов. ")
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true)
          ]))
    ]),
    (_ctx.showPagination && _ctx.showVueListCW)
      ? (_openBlock(), _createBlock(_component_paginate, {
          key: _ctx.paginationKey,
          value: _ctx.currentPage,
          "page-count": _ctx.pageCount,
          "page-range": 5,
          "margin-pages": 1,
          "click-handler": _ctx.onPageChange,
          "prev-text": 'Назад',
          "next-text": 'Дальше',
          "container-class": 'pagination-vue',
          "page-class": 'pagination-vue__item'
        }, null, 8 /* PROPS */, ["value", "page-count", "click-handler"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}